<template>
  <div>
    <!--    기본정보-->
    <field-select-module
      v-model="form.stdInfo"
      :board="this.board"
      :is-print="isPrint"
      :types="['com_name', 'field_name', 'date',]"
      :mobile-types="['field_name']"
      :typeslabel="{
        com_name: '학교명',
      }"
    />

    <!--    유해·위험요인 파악 조사 정보-->
    <div class="mt-28px">
      <h5 class="mb-4"><i class="dot"></i> 유해·위험요인 파악 조사 정보</h5>
      <div class="writeGridContainer">
        <div class="writeGridLineItem">
          <div>실시방법</div>
          <p v-if="isPrint" class="print-input">{{ form.inputA_1 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="form.inputA_1" placeholder="근로자의 상시 제안, 설문 및 위험성평가 수행자가 현장 근로자와 면담을 통해 직접 경험한 유해∙위험요인을 찾음"/>
        </div>

        <div>
          <div>수행자</div>
          <p v-if="isPrint" class="print-input">{{ form.inputA_2 }}</p>
          <ml-input v-else v-model="form.inputA_2" :readonly="board.readonly"/>
        </div>
        <div>
          <div>서명</div>
          <sign-field v-model="form.sign1.sign" :readonly="board.readonly" />
        </div>
        <div>
          <div>수행일시</div>
          <p v-if="isPrint" class="print-input">
            {{ form.inputA_4 }} ~ {{ form.inputA_5 }}
          </p>
          <div class="flex" style="align-items: center;">
            <date-selector v-model="form.inputA_4"/>
            <span class="mx-2">~</span>
            <date-selector v-model="form.inputA_5"/>
          </div>
        </div>
      </div>
    </div>

    <!-- 청취조사 내용 ※육하원칙(누가, 언제, 어디서, 무엇을, 어떻게, 왜)에 따라 작성 -->
    <table-custom
      :board="board"
      :is-print="isPrint"
      title="청취조사 내용 ※육하원칙(누가, 언제, 어디서, 무엇을, 어떻게, 왜)에 따라 작성"
      :tableData="[
        { id: 'name', title: '근로자 성명/직책', type: 'text' },
        { id: 'experience', title: '경험담', type: 'textarea' },
        { id: 'disaster', title: '재해형태', type: 'disaster' },
      ]"
      :mobile="['name', 'disaster']"
      v-model="form.hearList"
      class="mt-28px"
      @input="updateList"
    />

    <!--    근로자 및 수행자 의견-->
    <div class="mt-28px">
      <h5 class="mb-4"><i class="dot"></i> 근로자 및 수행자 의견</h5>
      <div class="writeGridContainer">
        <div class="writeGridLineItem">
          <div>근로자 의견</div>
          <span v-if="isPrint" class="print-textarea"> {{ form.inputC_1 }} </span>
          <ml-textarea v-else rows="5" v-model="form.inputC_1" :readonly="board.readonly" placeholder="유해·위험 경험의 원인과 반성할 점" />
        </div>
        <div class="writeGridLineItem">
          <div>수행자 의견</div>
          <span v-if="isPrint" class="print-textarea"> {{ form.inputC_2 }} </span>
          <ml-textarea v-else rows="5" v-model="form.inputC_2" :readonly="board.readonly" placeholder="경험에 대한 조언" />
        </div>
      </div>
    </div>

    <!--    사진대지-->
    <photo-upload-grid-module
      :row-count="2"
      :grid-count="2"
      v-model="form.photoList"
      :is-print="isPrint"
      :readonly="board.readonly"
      section-title="사진대지"
    />

    <!--    파일첨부-->
    <file-upload-module
      id="fileList"
      class="w-full mt-4 hidden xl:block"
      v-model="form.fileList"
      :is-print="isPrint"
      :readonly="board.readonly"
    ></file-upload-module>
  </div>
</template>

<script>
import PopupPlanProject from "@/views/project/popup/PopupPlanProject";
import DateSelector from "@/components/selector/DateSelector";
import PopupProjectSetting from "@/views/project/PopupProjectSetting";
import MemberSelector from "@/components/selector/MemberSelector";
import CompanySelector from "@/components/selector/CompanySelector";
import FileUploader from "@/components/FileUploader";
import FileUploadModule from "@/views/modules/FileUploadModule";
import TableInspect from "@/components/TableInspect";
import TableEquipment from "@/components/TableEquipment";
import DisasterClassSelector from "@/components/selector/DisasterClassSelector";
import MeasureStateSelector from "@/components/selector/MeasureStateSelector";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule";
import SignField from "@/components/SignField.vue";
import TableCustom from "@/components/TableCustom.vue";

export default {
  components: {
    TableCustom,
    SignField,
    PhotoUploadGridModule,
    FieldSelectModule,
    MeasureStateSelector,
    FileUploadModule,
    TableInspect,
    TableEquipment,
    DisasterClassSelector,
    FileUploader,
    CompanySelector,
    MemberSelector,
    PopupProjectSetting,
    DateSelector,
    PopupPlanProject,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  data() {
    return {
      form: {
        stdInfo: {},

        inputA_1: "",
        inputA_2: "",
        sign1: {
          name: "",
          sign: "",
        },
        inputA_4: "",
        inputA_5: "",

        hearList: [],
        disasters: "",

        inputC_1: "",
        inputC_2: "",

        photoList: [],
        fileList: [],
      },
    };
  },
  methods: {
    updateList(list) {
      this.form.hearList = list;

      this.form.disasters = "";
      for (const risk of this.form.hearList) {
        this.form.disasters += `${risk.disaster} `;
      }
    },
  },
};
</script>

<style scoped lang="scss">
$border: 1px solid #cdcdcd;
.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
}
.mt-component-form {
  margin-top: 15px;
}

/* uploaded File */
.h-upload {
  height: 470px;
}
.upload-content {
  border: $border;
  &:last-child {
    border-left: none;
  }
  &__title {
    height: 54px;
    line-height: 54px;
    text-align: center;
    background: #fafafa;
    border-bottom: $border;
  }
  &__input {
    height: 54px;
    background: #f9f9f9;
    border-top: $border;
    padding: 5px 15px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  &__file {
    height: calc(100% - 54px);
    width: 100%;
    padding: 14px;
  }
}
</style>
